import { propagationAxios } from 'trace-propagation';

import { Configuration, ContentEditApi, EmbeddingsApi, VoiceoverApi } from '@videoblocks/ml-text-service-client';

export const basePath = process.env.ML_TEXT_SERVICE_HOST ?? 'https://ml-text-service.internal.storyblocks.dev';

export const config = new Configuration({
    basePath,
});

// `propagationAxios` forwards incoming propagation headers to
// ml-text-service for Signadot sandbox routing.
export const contentEditApi = new ContentEditApi(config, undefined, propagationAxios);
export const embeddingsApi = new EmbeddingsApi(config, undefined, propagationAxios);
export const voiceoverApi = new VoiceoverApi(config, undefined, propagationAxios);
